import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-5_jiaban_no",
  "use": "icon-5_jiaban_no-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-5_jiaban_no\">\n<path d=\"M9 26.5C9 23.4624 11.4624 21 14.5 21H25.5C28.5376 21 31 23.4624 31 26.5V28.5C31 29.8807 29.8807 31 28.5 31H11.5C10.1193 31 9 29.8807 9 28.5V26.5Z\" fill=\"#BBD0EA\" />\n<circle cx=\"26.5\" cy=\"25.5\" r=\"6.5\" fill=\"#D3E3F7\" stroke=\"white\" stroke-width=\"1.5\" />\n<path d=\"M26.5 23V25.5L29 27\" stroke=\"white\" stroke-opacity=\"0.9\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<circle cx=\"20\" cy=\"14\" r=\"5\" fill=\"#C4C4C4\" />\n<circle cx=\"20\" cy=\"14\" r=\"5\" fill=\"#BBD0EA\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/5_jiaban_no.svg
// module id = CAZT
// module chunks = 45